import Header from "@/components/Header";

interface ResultsErrorProps {
  analysisId?: string;
}

export const ResultsError = ({ analysisId }: ResultsErrorProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-gray-900">404</h1>
          <h2 className="text-xl text-gray-700">Análise não encontrada</h2>
          {analysisId && (
            <p className="text-gray-500">
              Não foi possível encontrar a análise com ID: {analysisId}
            </p>
          )}
          <a
            href="/"
            className="inline-block mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Voltar para página inicial
          </a>
        </div>
      </main>
      <footer className="py-6 text-center text-gray-600 bg-white border-t">
        <p>&copy; {new Date().getFullYear()} SEO Analysis. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
};